(() => {
  const root = document.documentElement;
  const paletteButtons = document.querySelectorAll('[data-palette-value]');
  const allowedPalettes = ['palm', 'barbie', 'cream'];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const themeColors = {
    barbie: '#e9babd',
    palm: '#155c52',
    cream: '#f3dfb8',
  };
  let activeViewTransition = null;
  let fallbackCleanupTimer = null;

  function applyPalette(selectedPalette) {
    root.dataset.palette = selectedPalette;
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', themeColors[selectedPalette]);

    paletteButtons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.paletteValue === selectedPalette));
    });

    try {
      localStorage.setItem('mahjong-palette', selectedPalette);
    } catch (error) {
      // The visual preview still works when storage is unavailable.
    }
  }

  function setPalette(palette, animate = true) {
    const selectedPalette = allowedPalettes.includes(palette) ? palette : 'palm';

    if (!animate || root.dataset.palette === selectedPalette || reducedMotion.matches) {
      applyPalette(selectedPalette);
      return;
    }

    if (typeof document.startViewTransition === 'function') {
      activeViewTransition?.skipTransition();
      const transition = document.startViewTransition(() => applyPalette(selectedPalette));
      activeViewTransition = transition;
      transition.finished.finally(() => {
        if (activeViewTransition === transition) activeViewTransition = null;
      });
      return;
    }

    window.clearTimeout(fallbackCleanupTimer);
    root.classList.add('palette-is-transitioning');

    window.requestAnimationFrame(() => {
      applyPalette(selectedPalette);
      fallbackCleanupTimer = window.setTimeout(() => {
        root.classList.remove('palette-is-transitioning');
      }, 560);
    });
  }

  paletteButtons.forEach((button) => {
    button.addEventListener('click', () => setPalette(button.dataset.paletteValue));
  });

  setPalette(root.dataset.palette, false);
})();
